import { LocalizedHallOfFame } from '@app/types/hallOfFameTypes';
import { HallOfFameActionTypes, HallOfFameAction } from '@app/store/actionTypes/hallOfFameActionTypes';

const initialState: LocalizedHallOfFame = {};

export default (
  state = initialState,
  action: HallOfFameAction,
): LocalizedHallOfFame => {
  switch (action.type) {
    case HallOfFameActionTypes.SET_HALL_OF_FAME:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export { LocalizedHallOfFame };
